import { ToggleExtra } from '@common/components/Extras/controls/ToggleExtra/ToggleExtra';
import { generateGuestOptions } from '@common/components/Extras/utils';
import BlockSelectField from '@common/components/FormElements/BlockSelectField';
import { PackagesFormValues } from '@features/DynamicPackagesConfigurationWizard/types';
import { adaptExtras } from '@features/spa/pages/SpaDay/SpaPackageModal/SpaPackageExtras/utils';
import { some } from '@utils/some';
import { FC, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ConfigurationGroupType } from 'shared-types/SpaPackage';
import { Extra } from '@common/components/Extras';
import { useTranslations } from '@lang';
import { PageTitle } from '../../FormSteps.styles';
import { SpaExtrasTitleWrapper } from '../ExtrasSection.styles';
import { toSpaExtraEntries } from '../../../helpers/extrasEntries';
type SpaExtrasProps = {
  extras?: ConfigurationGroupType[] | null;
};

export const SpaExtras: FC<SpaExtrasProps> = ({ extras }) => {
  const { t } = useTranslations();
  const adaptedExtras = adaptExtras(extras);
  const { control, setValue, watch, getValues } = useFormContext<PackagesFormValues>();
  const guests = getValues('guests') || [];
  const guestsArray = guests.map((g) => g.guestDetails).filter(Boolean);
  const selectedExtras = (watch('spaExtras') || []).filter((e) => some(e.selectedGuestDetails));

  useEffect(() => {
    if (!adaptedExtras) {
      return;
    }
    // Prevents removing selected options when return to this step
    if (selectedExtras.length === 0) {
      setValue('spaExtras', toSpaExtraEntries(adaptedExtras));
    }
  }, []);

  return (
    <>
      <SpaExtrasTitleWrapper>
        <PageTitle>{t('treatment.extrasAndAdditions')}</PageTitle>
      </SpaExtrasTitleWrapper>
      {adaptedExtras &&
        adaptedExtras.map((extra, index) => {
          const isSelected = !!selectedExtras.find((e) => e.extra.id === extra.extra?.id);
          const guestOptions = generateGuestOptions(
            guestsArray,
            extra.id,
            extra.price?.amount || 0
          );

          return (
            <Extra
              key={extra.id}
              featured
              showPrice
              controls={(() => {
                if (guestOptions.length > 0) {
                  return (
                    <Controller
                      name={`spaExtras.${index}.selectedGuestDetails`}
                      control={control}
                      render={({ field }) => {
                        const selectedGuests = field.value;
                        return (
                          <BlockSelectField
                            options={guestOptions}
                            isMulti
                            className="spa-extras-select"
                            {...field}
                            onChange={(value) => {
                              field.onChange(value.map((v) => v.value));
                            }}
                            useNativeDropdownOnMobile={false}
                            value={guestOptions.filter((o) =>
                              some(
                                selectedGuests,
                                (val) =>
                                  val.firstName === o.value.firstName &&
                                  val.lastName === o.value.lastName &&
                                  val.title === o.value.title
                              )
                            )}
                          />
                        );
                      }}
                    />
                  );
                } else {
                  return (
                    <Controller
                      name={`spaExtras.${index}.selectedGuestDetails`}
                      control={control}
                      render={({ field }) => (
                        <ToggleExtra
                          input={{
                            value: some(field.value),
                            onChange: (value) => {
                              field.onChange(value ? [guestOptions[0].value] : []);
                            },
                          }}
                          {...field}
                        />
                      )}
                    />
                  );
                }
              })()}
              isSelected={isSelected}
              {...(extra as any)}
            />
          );
        })}
    </>
  );
};
